const data = {
  products: [
    {
      id: "5",
      name: "Polar Skate Co Devil T Shirt",
      description:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit.Doloremque eius, laborum sunt dolorem necessitatibusincidunt aut ducimus, quis, veritatis cum dolore tempora?Corporis, nostrum alias.",
      price: 1400,
      image: "./images/pic5.png",
    },
    {
      id: "6",
      name: "Polar Skate Co Devil T Shirt",
      description:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit.Doloremque eius, laborum sunt dolorem necessitatibusincidunt aut ducimus, quis, veritatis cum dolore tempora?Corporis, nostrum alias.",

      price: 2400,
      image: "./images/pic6.png",
    },
    {
      id: "7",
      name: "Polar Skate Co Devil T Shirt",
      description:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit.Doloremque eius, laborum sunt dolorem necessitatibusincidunt aut ducimus, quis, veritatis cum dolore tempora?Corporis, nostrum alias.",

      price: 1000,
      image: "./images/pic7.png",
    },
    {
      id: "8",
      name: "Polar Skate Co Devil T Shirt",
      description:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit.Doloremque eius, laborum sunt dolorem necessitatibusincidunt aut ducimus, quis, veritatis cum dolore tempora?Corporis, nostrum alias.",

      price: 1200,
      image: "./images/pic8.png",
    },
  ],
};
export default data;
